// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3JRdX","dragIcon":"Choice_dragIcon__3tVI2","left":"Choice_left__1K4JI","input":"Choice_input__2dKL1"};